import type { SelectorObject } from '../types';

export const createPlanTabsSelectors = {
  serviceFeesTab: 'create-plan-tabs-service-fees-tab',
  tierAndVolumePricingTab: 'create-plan-tabs-tier-and-volume-pricing-tab',
  promotionsTab: 'create-plan-tabs-promotions-tab',
} satisfies SelectorObject<'create-plan-tabs-'>;